// extracted by mini-css-extract-plugin
module.exports = {"Banner":"Banner--22p-E","SaleButton":"SaleButton--1ldZz","ViewButton":"ViewButton--2orkh"};